import { variant } from 'variant';
import type { VariantOf } from 'variant';
import type { TemplateSource } from './parse-command-options.js';
import type { McpConfigResult } from './components/mcp/getMcpResult.js';

export interface AppData {
  appId: string;
  appName: string;
}

export interface GenerationData {
  appData: AppData;
  packageName: string;
  template: TemplateSource;
  mcpConfigResult: McpConfigResult;
}

export const DeveloperAppsStatus = variant({
  NoApps: {},
  FailedLoadingApps: {},
  Available: {},
});

export type DeveloperAppsStatus = VariantOf<typeof DeveloperAppsStatus>;

export type CreationFlow = 'new' | 'existing';
